/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { JSONable } from "@irian-ro/abstract-resource";
import { RoutingSolutionItemViewModel } from "./routing-solution-item-view.model";

export class RoutingSolutionViewModelNew extends JSONable {

  uuid: string | undefined = undefined;

  routingSolutionItemViewSet: RoutingSolutionItemViewModel[] | undefined = undefined;

  spRoutingSolutionUuid: string | undefined = undefined;

  owner: string | undefined = undefined;

  shipmentGroupUuid: string | undefined = undefined;

  originalOfferUuid: string | undefined = undefined;

  originalOfferAccepted: boolean | undefined = undefined;

  originalOfferExpired: boolean | undefined = undefined;

  serviceProviderUuid: string | undefined = undefined;

  serviceProviderName: string | undefined = undefined;

  currency: string | undefined = undefined;

  costValue: string | undefined = undefined;

  details: string | undefined = undefined;

  pickupLocation: string | undefined = undefined;

  pickupDateTime: string | undefined = undefined;

  routePickupTimezone: string | undefined = undefined;

  deliveryLocation: string | undefined = undefined;

  deliveryDateTime: string | undefined = undefined;

  routeDeliveryTimezone: string | undefined = undefined;

  vehicleUuid: string | undefined = undefined;

  entityVehicleTypeValue: string | undefined = undefined;

  entityLicensePlate: string | undefined = undefined;

  driverUuid: string | undefined = undefined;

  entityDriverName: string | undefined = undefined;

  vehicleTypeValue: string | undefined = undefined;

  licensePlate: string | undefined = undefined;

  driverName: string | undefined = undefined;

  transitDays: string | undefined = undefined;

  createdBy: string | undefined = undefined;

  availableUntil: string | undefined = undefined;

  paymentTimeLimit: string | undefined = undefined;

}
